import { logSuggestionRejected } from '../telemetryHelpers/logDatapoints';
import store from '../store/store';
import { clearRecentlyRejectedSuggestionsTelemetry } from '../actions/smartComposePluginActions';
import { ISmartComposeSession } from '@qas/smartcompose-tslibrary/dist/src/session';

export default function logRecentlyRejectedSuggestions(
    currentSmartComposeSession: ISmartComposeSession
) {
    store().recentlyRejectedSuggestionsTelemetry.forEach(rejectedSuggestion => {
        logSuggestionRejected(rejectedSuggestion, currentSmartComposeSession);
    });
    clearRecentlyRejectedSuggestionsTelemetry();
}
